export class UserAdditionalData {
    id?: number;
    service?: string;
    userTitle?: string;
    userType?: string;
}